import { useState, useContext } from 'react';
import {
  Box,
  Container,
  Typography,
  CircularProgress,
} from '@mui/material';
import { PlayArrow, PlayCircleOutline } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { CardSurface } from '../../ui/CardSurface';
import { ButtonPrimary } from '../../ui/ButtonPrimary';
import InstallPromptBar from './pwa-install/InstallPromptBar';
import { InstallPromptContext } from './pwa-install/InstallPromptContext';

export function HomeScreen({ empresa, afericaoAberta, onIniciarAfericao, onContinuarAfericao, loading }) {
  const temAfericaoAberta = !!afericaoAberta;
  const { showInstallUI } = useContext(InstallPromptContext);

  const handleClick = () => {
    if (temAfericaoAberta) {
      onContinuarAfericao(afericaoAberta.id || afericaoAberta.Id);
    } else {
      onIniciarAfericao();
    }
  };

  return (
    <>
      <InstallPromptBar visible={true} />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.default',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          pt: showInstallUI ? '120px' : 0,
          transition: 'padding-top 0.3s ease-in-out',
        }}
      >
        <Container maxWidth="sm">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          style={{ width: '100%' }}
        >
          <CardSurface sx={{ p: 4, textAlign: 'center' }}>
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.1, type: 'spring', stiffness: 200 }}
            >
              <Typography
                variant="h4"
                component="h1"
                fontWeight={700}
                gutterBottom
                sx={{ mb: 4 }}
              >
                {empresa?.nome || empresa?.Nome || 'Aferição'}
              </Typography>

              <Box sx={{ mb: 4 }}>
                <ButtonPrimary
                  size="large"
                  onClick={handleClick}
                  disabled={loading}
                  startIcon={
                    loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : temAfericaoAberta ? (
                      <PlayCircleOutline />
                    ) : (
                      <PlayArrow />
                    )
                  }
                  sx={{
                    width: '100%',
                    maxWidth: 320,
                    py: 2,
                    fontSize: '1rem',
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {loading
                    ? 'Processando...'
                    : temAfericaoAberta
                    ? 'Continuar Aferição'
                    : 'Iniciar Aferição'}
                </ButtonPrimary>
              </Box>

              {temAfericaoAberta && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2 }}
                >
                  <Typography variant="body2" color="text.secondary">
                    Você tem uma aferição em andamento
                  </Typography>
                </motion.div>
              )}
            </motion.div>
          </CardSurface>
        </motion.div>
      </Container>
    </Box>
    </>
  );
}
